export default "__VITE_ASSET__07d87f80__"